
import apis  from "../../api/flow";
import {utils} from "../../utils/utils";
import {dateUtils} from "../../utils/dateUtils"

export default {
    name: "LoanAudit",
    props: {
      visible: {
          type: Boolean, 
          require: false 
      },
      propsOne: String
    },
    data() {
        return {
            activeName:'second',
            scrollHeight:400,
            isVisible:this.visible,
            flowInfo:null,
            model: {
                Title:'湖北省农业信贷融资担保有限公司:',
                Jkrmc:'',
                Type:1,
                Jkr:'',
                Sfzh:'',
                Tjje:'',
                Tjjedx:'',
                Qx:'',
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:''
            },
            model2: {
                Title:'湖北枝江农村商业银行股份有限公司:',
                Jkrmc:'',
                Type:2,
                Jkr:'',
                Sfzh:'',
                Tjje:'',
                Tjjedx:'',
                Qx:'',
                Sj:dateUtils.dateToStr("yyyy年MM月dd",new Date()),
                Hjhbh:''
            }
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if(meta&&meta.permBtns.length>0){
          this.permBtns = meta.permBtns
        }
    },
    created() {
    },
    activated() {
      // let that = this
      
    },
    deactivated(){
      let that = this
    
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
      getData(flowId) {
        let that = this;
        let queryPara = {
          flowId:flowId
        };
        apis.getDBTJInfo(queryPara).then(res => {
            if(res){
              that.model={
                Type:1,
                Title:'湖北省农业信贷融资担保有限公司:',
                Jkrmc:(res.Company===""||res.Company===null)?res.Name:res.Company,
                Jkr:res.Name,
                Sfzh:res.IdCard,
                Tjje:res.FinalMoney/1000000.0,
                Tjjedx:that.convertCurrency(res.FinalMoney/1000000.0),
                Qx:res.LoanMonth,
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:res.LoanTime,
              }
              let mc = ''
              if(res.PersonFlag===1){
                //个人
                mc = res.Name
              }else{
                mc = res.Company
              }
              that.model2 = {
                Type:2,
                Title:'湖北省农业信贷融资担保有限公司:',
                Jkrmc:mc,
                Tjje:res.FinalMoney/1000000.0,
                Tjjedx:that.convertCurrency(res.FinalMoney/1000000.0),
                Qx:res.LoanMonth,
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:res.LoanTime,
              }
            }else{
              that.model={
                Type:1,
                Title:'湖北省农业信贷融资担保有限公司:',
                Jkrmc:'',
                Jkr:'',
                Sfzh:'',
                Tjje:'',
                Tjjedx:'',
                Qx:'',
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:''
              }
              that.model2={
                Type:2,
                Title:'湖北省农业信贷融资担保有限公司:',
                Jkrmc:'',
                Jkr:'',
                Sfzh:'',
                Tjje:'',
                Tjjedx:'',
                Qx:'',
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:''
              }
            }
            if(that.flowInfo){
              // that.model.Title = that.flowInfo.BankName + ":"
              that.model2.Title = that.flowInfo.BankName + ":"
            }
        });
      },
      convertCurrency(currencyDigits) {
        var MAXIMUM_NUMBER = 99999999999.99;
        var CN_ZERO = "零";
        var CN_ONE = "壹";
        var CN_TWO = "贰";
        var CN_THREE = "叁";
        var CN_FOUR = "肆";
        var CN_FIVE = "伍";
        var CN_SIX = "陆";
        var CN_SEVEN = "柒";
        var CN_EIGHT = "捌";
        var CN_NINE = "玖";
        var CN_TEN = "拾";
        var CN_HUNDRED = "佰";
        var CN_THOUSAND = "仟";
        var CN_TEN_THOUSAND = "万";
        var CN_HUNDRED_MILLION = "亿";
        var CN_SYMBOL = "";
        var CN_DOLLAR = "";
        var CN_TEN_CENT = "";
        var CN_CENT = "";
        var CN_INTEGER = "";
       
       
        var integral; 
        var decimal;
        var outputCharacters; 
        var parts;
        var digits, radices, bigRadices, decimals;
        var zeroCount;
        var i, p, d;
        var quotient, modulus;
       
       
        currencyDigits = currencyDigits.toString();
        let strtemp = ''
        if (currencyDigits == "") {
          return "";
        }else{
          strtemp = currencyDigits.split("-");
          if (strtemp.length > 1) {currencyDigits=strtemp[1]}
        }
        if (currencyDigits.match(/[^,.\d]/) != null) {
          return "";
        }
        if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
          return "";
        }
       
       
        currencyDigits = currencyDigits.replace(/,/g, ""); 
        currencyDigits = currencyDigits.replace(/^0+/, ""); 
       
        if (Number(currencyDigits) > MAXIMUM_NUMBER) {
          return "";
        }
        parts = currencyDigits.split(".");
        if (parts.length > 1) {
          integral = parts[0];
          decimal = parts[1];
          decimal = decimal.substr(0, 2);
        }else {
          integral = parts[0];
          decimal = "";
        }
        digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
        radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
        bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
        decimals = new Array(CN_TEN_CENT, CN_CENT);
        outputCharacters = "";
        if (Number(integral) > 0) {
          zeroCount = 0;
          for (i = 0; i < integral.length; i++) {
            p = integral.length - i - 1;
            d = integral.substr(i, 1);
            quotient = p / 4;
            modulus = p % 4;
            if (d == "0") {
              zeroCount++;
            }else {
              if (zeroCount > 0){
                outputCharacters += digits[0];
              }
              zeroCount = 0;
              outputCharacters += digits[Number(d)] + radices[modulus];
            }
            if (modulus == 0 && zeroCount < 4) {
              outputCharacters += bigRadices[quotient];
            }
          }
          outputCharacters += CN_DOLLAR;
        }
       
        if (decimal != "") {
          for (i = 0; i < decimal.length; i++) {
            d = decimal.substr(i, 1);
            if (d != "0") {
              outputCharacters += digits[Number(d)] + decimals[i];
            }
          }
        }
        if (outputCharacters == "") {
          outputCharacters = CN_ZERO + CN_DOLLAR;
        }
        if (decimal == "" || decimal == 0) {
          outputCharacters += CN_INTEGER;
        }
        outputCharacters = CN_SYMBOL + outputCharacters;
        return outputCharacters;
      },
      onChangeClose(){
        this.isVisible = false
      },
      onChangeOpen(){
        this.isVisible = true
      },
      queryData(row){
        let that = this
        if(row){
          that.flowInfo = utils.deepCopy(row)
          that.getData(that.flowInfo.Id)
        }
      },
      onExportWord(flag){
        let that = this;
        let queryPara = utils.deepCopy(that.model)
        switch(flag){
          case 1:
            queryPara = utils.deepCopy(that.model)
            break
          case 2:
            queryPara = utils.deepCopy(that.model2)
            break
        }
        queryPara.FlowId = that.flowInfo.Id
        apis.exportWord(queryPara).then(res => {
            if(res){
              window.open(res)
            }
        });
      },
      onSubmit(flag){
        let that = this
          this.$confirm('确认推荐函或者担保函无误，确认后再无法修改, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
            let queryPara = utils.deepCopy(that.model)
            switch(flag){
              case 1:
                queryPara = utils.deepCopy(that.model)
                break
              case 2:
                queryPara = utils.deepCopy(that.model2)
                break
            }
            queryPara.FlowId = that.flowInfo.Id
            let param = {
                wordInfo:queryPara,
                flowInfo:{
                  Id:that.flowInfo.Id,
                  Route:11
                }
            }
            apis.confirmComplWord(param).then((res) => {
              if(res&&res.code){
                that.onChangeClose()
                that.$parent.bankAuditSucess()
              }else{
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            })
          })
      },
      onMoneyChange(value){
        this.model.Tjjedx = this.convertCurrency(value)
      },
      onMoneyChange2(value){
        this.model2.Tjjedx = this.convertCurrency(value)
      },
      calcTableHeight(){
        this.$nextTick(() => {
          var height1=$(".content-box .content").height();
          var height=height1-50-20-40;
          this.scrollHeight = height;
        });
      },
    },
  };
